import {
  getAllProducts,
  getProductById,
  isUserDeservedForGift,
  reserveProductToUser,
  isUserAlreadyOrdered,
} from './products.service';
import {
  GET_ALL_PRODUCTS_START,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_FAILED,
  GET_PRODUCT_BY_ID_START,
  GET_PRODUCT_BY_ID_SUCCESS,
  GET_PRODUCT_BY_ID_FAILED,
  RESERVE_PRODUCT_TO_USER_START,
  RESERVE_PRODUCT_TO_USER_SUCCESS,
  RESERVE_PRODUCT_TO_USER_FAILED,
  IS_USER_DESERVED_FOR_A_GIFT_START,
  IS_USER_DESERVED_FOR_A_GIFT_SUCCESS,
  IS_USER_DESERVED_FOR_A_GIFT_FAILED,
  IS_USER_DESERVED_FOR_THE_PRODUCT_START,
  IS_USER_DESERVED_FOR_THE_PRODUCT_SUCCESS,
  IS_USER_DESERVED_FOR_THE_PRODUCT_FAILED,
} from './products.types';

//! PLOP_APPEND_ACTION

export function isUserDeservedForGiftAction() {
  return async function _(dispatch) {
    const promise = isUserDeservedForGift(); // modify by your logic
    dispatch({
      type: [
        IS_USER_DESERVED_FOR_A_GIFT_START,
        IS_USER_DESERVED_FOR_A_GIFT_SUCCESS,
        IS_USER_DESERVED_FOR_A_GIFT_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function isUserAlreadyOrderedAction(productId) {
  return async function _(dispatch) {
    const promise = isUserAlreadyOrdered(productId);
    dispatch({
      type: [
        IS_USER_DESERVED_FOR_THE_PRODUCT_START,
        IS_USER_DESERVED_FOR_THE_PRODUCT_SUCCESS,
        IS_USER_DESERVED_FOR_THE_PRODUCT_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function reserveProductToUserAction({
  userId,
  productId,
  answers,
  type,
}) {
  return async function _(dispatch) {
    const promise = reserveProductToUser({ userId, productId, answers, type }); // modify by your logic
    dispatch({
      type: [
        RESERVE_PRODUCT_TO_USER_START,
        RESERVE_PRODUCT_TO_USER_SUCCESS,
        RESERVE_PRODUCT_TO_USER_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function getProductByIdAction(id) {
  return async function _(dispatch) {
    const promise = getProductById(id); // modify by your logic
    dispatch({
      type: [
        GET_PRODUCT_BY_ID_START,
        GET_PRODUCT_BY_ID_SUCCESS,
        GET_PRODUCT_BY_ID_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function getAllProductsAction() {
  return async function _(dispatch) {
    const promise = getAllProducts();
    dispatch({
      type: [
        GET_ALL_PRODUCTS_START,
        GET_ALL_PRODUCTS_SUCCESS,
        GET_ALL_PRODUCTS_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}
